import {
  GET_ME_PRODUCTS_REQUEST,
  GET_ME_PRODUCTS_SUCCESS,
  GET_ME_PRODUCTS_FAILURE,
} from '../../constants/action-types';

const getInitialState = () => {
  return {
    isLoading: false,
    data: {},
    error: false,
  };
};

const initialState = getInitialState();

const meProducts = (state = initialState, action) => {
  const types = {
    [GET_ME_PRODUCTS_REQUEST]: () => ({
      ...state,
      isLoading: true,
    }),
    [GET_ME_PRODUCTS_SUCCESS]: () => ({
      ...state,
      isLoading: false,
      error: false,
      data: action.response,
    }),
    [GET_ME_PRODUCTS_FAILURE]: () => ({
      ...state,
      isLoading: false,
      error: true,
      message: action.message,
    }),
  };

  if (!types[action.type]) {
    return state;
  }

  return types[action.type]();
};

export default meProducts;
